import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Plus, Trash2 } from 'lucide-react';

export default function MedicationList({ items = [], onChange, disabled }) {
  const list = Array.isArray(items) ? items : [];

  const updateRow = (index, field, value) => {
    const next = list.map((row, i) => (i === index ? { ...row, [field]: value } : row));
    onChange(next);
  };

  const addRow = () => {
    onChange([...list, { name: '', dose: '', frequency: '' }]);
  };

  const removeRow = (index) => {
    onChange(list.filter((_, i) => i !== index));
  };

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between gap-2">
        <Label>Medicamentos actuales</Label>
        <Button type="button" variant="outline" size="sm" disabled={disabled} onClick={addRow}>
          <Plus className="w-4 h-4 mr-1" />
          Agregar
        </Button>
      </div>
      {list.length === 0 ? (
        <p className="text-sm text-muted-foreground">Sin medicamentos registrados.</p>
      ) : (
        list.map((row, index) => (
          <div
            key={`med-${index}`}
            className="grid grid-cols-1 md:grid-cols-[1fr_1fr_1fr_auto] gap-2 items-end border rounded-lg p-3"
          >
            <div>
              <Label className="text-xs">Medicamento</Label>
              <Input
                className="h-9 mt-0.5"
                value={row.name || ''}
                disabled={disabled}
                onChange={(e) => updateRow(index, 'name', e.target.value)}
              />
            </div>
            <div>
              <Label className="text-xs">Dosis</Label>
              <Input
                className="h-9 mt-0.5"
                value={row.dose || ''}
                disabled={disabled}
                onChange={(e) => updateRow(index, 'dose', e.target.value)}
              />
            </div>
            <div>
              <Label className="text-xs">Frecuencia</Label>
              <Input
                className="h-9 mt-0.5"
                value={row.frequency || ''}
                disabled={disabled}
                onChange={(e) => updateRow(index, 'frequency', e.target.value)}
              />
            </div>
            <Button
              type="button"
              variant="ghost"
              size="icon"
              disabled={disabled}
              onClick={() => removeRow(index)}
              aria-label="Quitar medicamento"
            >
              <Trash2 className="w-4 h-4 text-destructive" />
            </Button>
          </div>
        ))
      )}
    </div>
  );
}
